import { GetAgentStatusResponse } from './types';

// Shared mock used by RewardsTab and TwentySixForTwentySix when
// REWARDS_MOCK_ENABLED is set. Not imported in production paths.
// progress values are internally consistent with MOCK_REWARDS_CONFIG's
// entry_threshold of 5: 3 binds + 2 remaining = 5-per-entry cycle.
export const MOCK_AGENT_STATUS: GetAgentStatusResponse = {
  availableEntries: 2,
  hasActiveAttempt: false,
  activeAttemptId: null,
  lastResult: null,
  progress: { qualifyingBindsCurrentPhase: 3, policiesUntilNextEntry: 2 },
  phase: {
    number: 1,
    code: 'ACT1',
    name: 'Act 1',
    start: '',
    end: '',
    attemptType: 'SPIN',
  },
  balance: { regular: 350, bonus: 0, bonusExpiresAt: null },
};
